<template>
  <home-page></home-page>
</template>

<script>
import HomePage from '../components/home-page/index.vue';

export default { components: { HomePage } };

</script>
